




































































































import { RouterModule } from "@/store/module/router";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import eventBus from "@/utils/bus";
const appVersion = process.env.VUE_APP_Version;
@Component({
  name: "layoutAside",
  components: {},
})
export default class extends Vue {
  isCollapse: boolean = false;
  version: string = appVersion;
  menu: {}[] = [];
  @Watch("$route")
  onRouteChange(n: any) {
    this.updateMenuActive(n);
  }
  created() {
    const menuResult: any[] = [];
    const asyncRouters = RouterModule.asyncRouters[0].children;
    asyncRouters.map((item: any) => {
      if (item.hidden) {
        return false;
      }
      if (item.redirect) {
        return false;
      }
      if (item.children) {
        item.children = item.children.filter((it: any) => {
          return !it.hidden;
        });
      }
      item.active = false;
      menuResult.push(item);
    });
    this.menu = menuResult;
    // 监听左侧栏折叠
    eventBus.$on("collapse", (item: any) => {
      this.isCollapse = item;
    });
    // 初始化菜单激活态
    this.$nextTick(() => {
      this.updateMenuActive(this.$route);
    });
  }
  beforeDestroy() {
    eventBus.$off("collapse");
  }
  updateMenuActive(n: any) {
    const child = n.name;
    let father = "";
    if (n.matched && n.matched.length > 1) {
      father = n.matched[1].name;
    }
    const copy = [...this.menu];
    copy.map((item: any) => {
      if (item.name === father) {
        item.active = true;
      } else {
        item.active = false;
      }
      if (item.children) {
        item.children.map((it: any) => {
          if (it.name === child) {
            it.active = true;
          } else {
            it.active = false;
          }
        });
      }
    });
    this.menu = copy;
  }
  handleLinkTitleClick(item: any, i: number) {
    if (!item.children || item.children.length === 0) {
      // 无子级
      this.$router.push({
        name: item.name,
      });
    } else {
      if (this.isCollapse) {
        return false;
      }
      const copy = [...this.menu];
      copy.map((item: any, index: number) => {
        if (index === i) {
          item.active = !item.active;
        } else {
          item.active = false;
        }
      });
      this.menu = copy;
    }
  }
  handleLinkClick(name: string) {
    this.$router.push({
      name: name,
    });
  }
}
